module.exports = __webpack_public_path__ + "static/img/case-7luoshui.ce42a39d.jpg";